<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
// import Swal from "sweetalert2";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager, DxFilterRow, DxRemoteOperations,
    Loader
  },
  data() {

    return {
      title: "Vindi",
      items: [
        {
          text: "Mov",
          href: "/"
        },
        {
          text: "MovYapay",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      exibEmit: true,
      exibDest: false,
      exibAmbos: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,

      empresaData: null,

      selectedStatus: null,
      options: [
        { value: null,  text: 'Todos' },
        { value: 'approved',  text: 'Faturados'},
        { value: 'canceled',  text: 'Cancelados'},
        { value: 'failed',  text: 'Com falhas'},
        { value: 'waiting_payment',  text: 'Aguardando pagamento'},
      ],

      selectedRowKeys: [],

      totalCount: 0,
      totalProcessadosSucesso: 0,
      totalProcessadosPendente: 0,
      totalProcessadosCancelados: 0,

      danfelink: null,
      pdflink: null,
      iddata: null,

      showModalLink: false,
      showModalReprocessamentoData: false,
      dtIniReproc: null,
      dtFimReproc: null,
    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted movyapay-list')
    this.atualizaDataList()
  },

  methods: {
    filtrarPendentes() {
      console.log('filtrarPendentes');

      this.$refs.dataGridRefKey.instance.filter([
        ["movyapay_enviotrackflag", "=", "false"],
        "and",
        ["movyapay_urltracking", "=", "null"],
        "and",
        ["movyapay_stsyapay", "=", "approved"]
      ]);
    },
    reprocessarPendentes(){
      Swal.fire({
        position: 'top-end',
        icon: 'info',
        title: 'Reprocessando dados!',
        showConfirmButton: false,
        showCancelButton: false,
        timer: 1000
      }).then(() => {
        api.get(`${getBaseUrl()}api/reprocperiodvindi`)
        .then((res) => {
          console.log('then reprocessarPendentes')
          console.log(res.data)

          let icon = 'success'
          if(!res.data.success){
            icon = 'error'
          }

          Swal.fire({
            position: 'top-end',
            icon: icon,
            title: res.data.message,
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000
          }).then(() => this.atualizaDataList())
        })
      })
    },

    showFuncoes(row){
      console.log('showFuncoes')
      this.linhaAtual = row.values
      this.iddata = row.data.movyapay_id

      // console.log(this.vindList)
      let itemAtual = this.vindList.find(movyapay_id => movyapay_id === this.iddata)
      console.log(itemAtual)
      this.showModalFuncoes = true
    },

    linkDanfe(danfelink){
      console.log('linkDanfe')

      if (danfelink) {
        window.open(danfelink, '_blank')
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Link Danfe não disponível!",
          showConfirmButton: false,
          timer: 1500
        })
      }
      // const routeData = this.$router.resolve(`${danfelink}`)
      window.open(danfelink, '_blank')

      this.showModalLink = false;
    },

    linkPdf(pdflink){
      console.log('linkPdf')
      // const routeData = this.$router.resolve(`${pdflink}`)
      window.open(pdflink, '_blank')

      this.showModalLink = false;
    },

    reenviarTracking(){
      console.log('Reprocessing Yapay tracking link...')
      console.log(this.iddata)

      return api.get(`${getBaseUrl()}api/repvindipedido`, {
        params: {
          iddata: this.iddata
        }
      }).then((res) => {
        console.log('then reprocessing vindi')
        console.log(res.data)


        this.showModalFuncoes = false
        this.iddata = null
      })
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))


      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    applyStatusFilter() {
      console.log('Selected Status:', this.selectedStatus);
      this.$refs.dataGridRefKey.instance.columnOption('movyapay_stsyapay', 'filterValue', this.selectedStatus);
    },

    carregouGrid(e){
      console.log('carregouGrid')
      // console.log(this.dataGrid.deselectAll())
      // e.component.deselectAll

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Transações Vindi(YaPay): ${dtIniFormated} - ${dtFimFormated}`
    },

    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const exibEmit = this.exibEmit
      const exibDest = this.exibDest
      const exibAmbos = this.exibAmbos
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      const self = this //Armazenando this no contexto

      this.dataList = new CustomStore({
        key: "movyapay_id",
        load: function(loadOptions){

          console.log('exibEmit')
          console.log(exibEmit)

          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'ee': exibEmit,
            'ed': exibDest,
            'ea': exibAmbos,
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/indexvindi`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data_0')
            console.log(response.data)

            self.totalCount = response.data[1];
            self.totalProcessadosSucesso = response.data[2];
            self.totalProcessadosPendente = response.data[3];
            self.totalProcessadosCancelados = response.data[4];

            return {
              data: response.data[0],
              totalCount: response.data[1]
            }
          })
        },
      })
    },

    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.atualizaDataList()
    },

    //Alterar para modal que o célio fez
    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)

      this.iddata = row.data.movyapay_id
      console.log(this.iddata)

      this.danfelink = row.data.movbling_linkdanfe
      this.pdflink = row.data.movbling_linkpdf
      this.tracklink = row.data.movyapay_urltracking

      this.showModalLink = true;

    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "movyapay_stsyapay") {
          const valStatus = e.data.movyapay_stsyapay
          let corStatus = 'rgba(255,255,240,0.5)'
          switch (valStatus) {
            case 'canceled':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'failed':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'approved':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'waiting_payment':
              corStatus = 'rgba(0,58,78,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'canceled':
          return 'Cancelado'
        case 'approved':
          return 'Faturado'
        case 'failed':
          return 'Com falhas'
        case 'waiting_payment':
          return 'Aguardando pagamento'
        default:
          return 'Em processamento...'
      }
      // return e.value
    },
  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>
      <div class="card-body border-top mb-3">
        <h5 class="text-muted mb-4">Panorama geral do período Filtrado:</h5>
        <div class="text-center">
          <div class="row">
            <div class="col-sm-3">
              <div>
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-line-chart text-info"></i>
                </div>

                <p class="text-muted mb-2">Processados</p>
                <h5>{{totalCount}}</h5>
              </div>
            </div>

            <div class="col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-check-double text-success"></i>
                </div>

                <p class="text-muted mb-2">Enviados</p>
                <h5>{{ totalProcessadosSucesso }}</h5>
              </div>
            </div>

            <div class="col-sm-3" @click="filtrarPendentes" id="pendente-falha">
              <div class="mt-4 mt-sm-0">
                <span class="badge bg-danger">Clique para filtrar</span>
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bxs-comment-error text-danger"></i>
                </div>

                <p class="text-muted mb-2">Pendentes/Falhas</p>
                <h5>{{ totalProcessadosPendente }}</h5>
              </div>
            </div>

            <div class="col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-block text-danger"></i>
                </div>
                <p class="text-muted mb-2">Cancelados</p>
                <h5>{{ totalProcessadosCancelados }}</h5>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div>
      <DxToolbar>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="increaselinespacing"
              text="Reprocessar pedidos pendentes"
              :on-click="reprocessarPendentes"
          />
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <b-dropdown
              v-model="selectedStatus"
              class="float-end"
              right
              style="margin-left: 5px"
              variant="primary"
              menu-class="dropdown-menu-end"
              @change="applyStatusFilter">
            <template v-slot:button-content>
              <i class="mdi mdi-filter-plus me-1"></i> Filtrar Status
            </template>
            <b-form-select v-model="selectedStatus">
              <option :value="null" disabled>-- Selecione uma opção --</option>
              <option v-for="option in options" :value="option.value" :key="option.value">
                {{ option.text }}
              </option>
            </b-form-select>
          </b-dropdown>
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true"/>


        <DxSelection mode="multiple"/> <!--:allow-select-all="false"-->
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strMovYapayList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping/>

        <!-- PARTE DE TRANSAÇÕES VINDI -->
        <DxColumn
            :width="330"
            caption="Transações Vindi"
            alignment="center"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="movyapay_id"
              sort-order="desc"
              caption="ID"
              data-type="number"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movbling_numnf"
              sort-order="desc"
              caption="Nota fiscal"
              data-type="text"
              alignment="right"
              :filter-operations="['contains','=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movyapay_criacaoorder"
              caption="Data Transação"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movyapay_attorder"
              caption="Data última atualização"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>


          <DxColumn
              data-field="movyapay_stsyapay"
              caption="Status"
              alignment="center"
              data-type="text"
              :customize-text="nomeStatus"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movyapay_ordernumber"
              caption="Order Number"
              alignment="center"
              data-type="text"
              :filter-operations="['contains','=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movyapay_enviotrackflag"
              caption="Disparo de envio(flag)"
              alignment="center"
              data-type="boolean"
              :filter-operations="['contains','=', '<>']"
              :allowHeaderFiltering="true"/>



        </DxColumn>

        <!-- PARTE DE TRANSAÇÕES BLING -->
        <DxColumn
            :width="330"
            caption="BLING"
            alignment="center"
            :allowHeaderFiltering="false">

          <DxColumn
              :width="80"
              data-field="movbling_mktplaceid"
              caption="Transação Bling"
              alignment="right"
              data-type="text"
              :filter-operations="['contains', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              :width="80"
              data-field="movbling_blingid"
              caption="Número"
              alignment="right"
              data-type="text"
              :filter-operations="['contains','=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              :width="100"
              data-field="movbling_dtpedido"
              caption="Data pedido"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              :width="100"
              data-field="movbling_dtsaida"
              caption="Data saída"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>
          <!-- FIM PARTE DE TRANSAÇÕES BLING -->
        </DxColumn>

        <!-- PARTE DE DADOS DESTINATÁRIO -->
        <DxColumn
            :width="330"
            caption="Destinatário"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="pessoa_nome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="pessoa_cnpj"
              caption="CPF/CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>

        <!-- PARTE DE DADOS TRANSPORTADORA -->
        <DxColumn
            :width="330"
            caption="Transportador"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="movyapay_tipotrck"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>
      </DxDataGrid>
    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal size="md" :title="'Ações:'"
             v-model="showModalLink" centered hide-footer>

      <div class="d-flex col-10 justify-content-start">
        <b-button variant="outline-info"
                  class="action-icon mx-2"
                  @click="linkDanfe(danfelink)">
          <i class="bx bx-money font-size-18"></i>
          Link Danfe
        </b-button>

        <b-button variant="outline-primary"
                  class="action-icon mx-2"
                  @click="linkPdf(pdflink)">
          <i class="bx bxs-file-pdf font-size-18"></i>
          Link PDF
        </b-button>

        <b-button variant="outline-warning"
                  class="action-icon mx-2"
                  @click="reenviarTracking">
          <i class="bx bx-rocket font-size-18"></i>
          Reenviar link tranking
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
  #pendente-falha:hover{
    cursor: pointer;
  }
</style>